var map = {
	"./traditional-1.jpg": 78280,
	"./traditional-10.jpg": 62887,
	"./traditional-11.jpg": 82917,
	"./traditional-12.jpg": 63157,
	"./traditional-2.jpg": 91217,
	"./traditional-3.jpg": 43208,
	"./traditional-4.jpg": 4356,
	"./traditional-5.jpg": 63161,
	"./traditional-6.jpg": 98411,
	"./traditional-7.jpg": 370,
	"./traditional-8.jpg": 57186,
	"./traditional-9.jpg": 67552
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 13400;